export default "__VITE_ASSET__HFMnKyhw__"